import React from 'react';
import { Modal, Typography, Form, Input, Button } from 'antd';
// import { Selection } from '../../common';
import { message } from '../../biz';
import { generators, asserts } from '../../../utils';
import { saveRemind } from '../../../service/common';
import '../RemindModal/index.less';

const { Title } = Typography;
const { generatorObject } = generators;

const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 18 },
};

export default Form.create()(
  ({
    form,
    visible, // days = [],
    number = 0,
    isAddRemark = false,
    defaultMobile,
    selectedValue = {},
    handleHide,
    handleSuccess,
  }) => {
    const { getFieldDecorator, validateFields } = form;
    const handleCancel = () => handleHide();
    const submit = async (data) => {
      const res = await saveRemind(data);
      if (res.success) {
        const result = generatorObject(res.data);
        if (!result.success) {
          message.error(result.message);
          return;
        }
        message.success('设置成功');
        handleHide();
        asserts.isFunction(handleSuccess) && handleSuccess();
      }
    };
    const handleSubmit = () => {
      validateFields((err, values) => {
        if (err) return;
        const { arImitm, arMcu } = selectedValue;
        //const { arItemqty } = values;
        const addParams = {
          ...values,
          // arItemqty: arItemqty ? arItemqty : 0.001,
          arType: '1',
          arDelStatus: '1',
        };
        const params = { ...addParams, arImitm, arMcu };
        const submitParams = isAddRemark ? addParams : params;
        submit(submitParams);
      });
    };
    return (
      <Modal
        visible={visible}
        footer={null}
        destroyOnClose={true}
        title={
          <>
            <Title level={4}>备货提醒设置</Title>
            {!isAddRemark && <span>（已有{number}人设置）</span>}
          </>
        }
        width={680}
        wrapClassName="remindModal"
        onCancel={handleCancel}
      >
        <Form {...formItemLayout}>
          <Form.Item wrapperCol={{ span: 24 }} className="custom-item">
            若您希望我司对某产品扩大库存备货，可根据您的使用需求，在此提出建议，我司会认真考虑您的需求
          </Form.Item>
          <Form.Item label="手机号码" className="special-item custom-item">
            {getFieldDecorator('arMobile', {
              initialValue: defaultMobile,
              rules: [
                {
                  required: true,
                  message: '请输入手机号码',
                },
                {
                  pattern: /^[0-9]{11}$/,
                  message: '请输入11位手机号码',
                },
              ],
            })(<Input style={{ width: 200 }} />)}
          </Form.Item>
          {/* <Form.Item label="需求数量" className="special-item">
            {getFieldDecorator('arItemqty', {
              initialValue: `${selectedValue.arItemqty}` !== '0.001' ? selectedValue.arItemqty : '',
            })(<InputNum style={{ width: 200 }} suffix="千支" />)}
          </Form.Item>
          <Form.Item label="期望有货时间" className="special-item">
            {getFieldDecorator('arDay', {
              initialValue: selectedValue.arDay,
            })(
              <Selection
                source={days}
                transfer={{ key: 'code', code: 'code', name: 'desc' }}
                style={{ width: 200 }}
              />,
            )}
          </Form.Item> */}
          <Form.Item wrapperCol={{ span: 24 }} className="custom-item">
            建议示例：DIN933 304 10*50
            多用于某行业，我司月均使用8000支，建议备货10000支，建议备于某仓，该产品我司使用高峰期在5-6月份，月均使用N支，使用低迷期在7-9月份，月使用M支
          </Form.Item>
          <Form.Item className="special-item" wrapperCol={{ span: 24 }}>
            {getFieldDecorator('arRemark', {
              rules: [{ required: 'true', message: '请输入内容' }],
              initialValue: selectedValue.arRemark,
            })(<Input.TextArea placeholder="内容为空不可提交" />)}
          </Form.Item>
          <Form.Item wrapperCol={{ span: 12, offset: 11 }} className="custom-item">
            <Button className="btn-info" type="primary" onClick={handleSubmit}>
              提交
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  },
);
